import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

import { useEffect, useRef } from 'react'

import { Radar } from 'react-chartjs-2'
import { iEscala, iGrafico } from '../../../../../interfaces'

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

interface iRadarData {
  grafico: iGrafico
  escala: iEscala
  getBlob: (base64: string) => void
}

interface iChartProviderProps {
  generateChartBlob: () => string
}

function useChartState(ChartRef: any): iChartProviderProps {
  function generateChartBlob(): string {
    return ChartRef.current.canvas.toDataURL()
  }

  return { generateChartBlob }
}

export const RadarChartJs: React.FC<iRadarData> = ({
  grafico,
  escala,
  getBlob
}) => {
  const stepSize = (escala.respostas[0]?.peso ?? 0) - (escala.respostas[1]?.peso ?? 0) ?? 0
  function AbreviarNomesGrandes(): string[] {
    return grafico.competencias.map((e) => {
      if (e.length > 19) {
        return e.substring(0, 19) + '...'
      } else {
        return e
      }
    })
  }

  const canvasReference = useRef(null)

  const { generateChartBlob } = useChartState(canvasReference)

  function ObterCor(pos: number): string {
    if (grafico.dados.length === 1) {
      return colors[pos]
    } else {
      return grafico.dados[pos].nome.includes('Média sem autoavaliação') ? colors[colors.length - 1] : colors[pos]
    }
  }

  const colors = ['#1961E0', '#27AE60', '#FFD166', '#9B51E0', '#E63946', '#F4A261']

  const Shapes = ['circle', 'star', 'triangle', 'rectRot', 'rectRounded']

  const options = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14
          },
          padding: 20
        }
      }
    },
    scales: {
      r: {
        min: 0,
        max: Math.max(...escala.respostas.map(e => e.peso)),
        ticks: {
          min: 0,
          max: 10,
          stepSize: stepSize,
          font: {
            size: 12
          },
          z: 1
        },
        pointLabels: {
          color: '#000',
          font: {
            size: 14
          }
        },

        angleLines: {
          color: '#bdbdbd'
        },

        grid: {
          color: '#bdbdbd'
        }
      }
    }
  }

  const data = {
    labels: AbreviarNomesGrandes(),
    datasets: grafico.dados.map((e, i) => {
      return {
        label: e.nome,
        data: e.medias,
        fill: false,
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: ObterCor(i),
        backgroundColor: ObterCor(i),
        borderColor: ObterCor(i),
        pointRadius: i === 0 ? 4 : 6,
        pointStyle: Shapes[i]
      }
    })
  }

  const plugin = {
    id: 'custom_canvas_background_color',
    beforeDraw: (chart: any) => {
      const { ctx } = chart
      ctx.save()
      ctx.globalCompositeOperation = 'destination-over'
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, chart.width, chart.height)
      ctx.restore()
    }
  }

  useEffect(() => {
    setTimeout(() => {
      getBlob(generateChartBlob())
    }, 1000)
  }, [grafico.dados])

  return (
    <Radar
      options={options}
      data={data}
      ref={canvasReference}
      plugins={[plugin]}
    />
  )
}
